module.exports = __webpack_public_path__ + "img/indu_active_5.4b7d1508.png";